export const AUTH_KEY = 'auth';